//cspell:disable
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from '../Useletter';
import Foter from '../Foter';

function Crew() {
  return (
    <div>
      {/* First Row */}
      <Container fluid className="py-4">
        <Row className="g-3">
          <Col xs={12} md={6}>
            <div className="box-cont">
              <div className="img-bo">
                <img
                  src="https://www.junaidjamshed.com/media/wysiwyg/Kameez-Shalwar_1.jpg"
                  alt="Kameez Shalwar"
                  className="img-fluid rounded"
                />
              </div>
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div className="box-cont">
              <div className="img-bo">
                <img
                  src="https://www.junaidjamshed.com/media/wysiwyg/kurta-trouser-2.jpg"
                  alt="Kurta Trouser"
                  className="img-fluid rounded"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
<br /><br /><br />
      {/* Second Row */}
      <Container fluid className="py-4">
        <Row className="g-3">
          <Col xs={12} md={6}>
            <div className="box-cont">
              <div className="img-bo">
                <img
                  src="https://www.junaidjamshed.com/media/wysiwyg/UNStitched.jpg"
                  alt="Unstitched"
                  className="img-fluid rounded"
                />
              </div>
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div className="box-cont">
              <div className="img-bo">
                <img
                  src="https://www.junaidjamshed.com/media/wysiwyg/FW24.jpg"
                  alt="FW24"
                  className="img-fluid rounded"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
 <br /><br /><br />
      {/* Footer & Newsletter */}
      <Useletter />
      <Foter />
    </div>
  );
}

export default Crew;
